<div class="grid grid-rows-[1fr_auto_1fr] h-screen">
    <app-header class="row-span-1"></app-header>
    <router-outlet class="row-span-1"></router-outlet>
    <app-footer class="row-span-1"></app-footer>
</div>
